// Скидка-процент: «цена до» = цена продажи / (1 − %), целые рубли вверх.
// Процент один на весь товар; у размеров «цена до» считается от цены выбранного размера.

export const hasDiscount = (product) => {
  const d = Number(product?.discount_percent);
  return Number.isFinite(d) && d > 0;
};

export const priceBefore = (price, percent) => {
  const p = Number(percent);
  const base = Number(price);
  if (!(p > 0) || !(base > 0)) return null;
  return Math.ceil(base / (1 - p / 100));
};
